import { UnscheduledEvent } from '../../types';

/**
 * Serializes a record's opening state so later edits can be detected (drives the
 * Update button's dirty check). Kept as a pure module-level function shared by
 * EventModal and the hooks that passively refresh live fields (so they can fold
 * their refresh into the opening snapshot and avoid a spurious dirty flag).
 */
export function buildOpeningSnapshot(event: UnscheduledEvent): string {
  return JSON.stringify({
    form: event,
    defects: event.defects || [],
    noteEntries: event.noteEntries || [],
    barriers: event.barriers || [],
    ertsHistory: event.ertsHistory || [],
    defectHistory: event.defectHistory || {},
    selectedChapters: event.selectedChapters || {},
    selectedSections: event.selectedSections || {},
    auditEntries: event.auditEntries || [],
  });
}
